import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const notificationFragment = gql`
  fragment notificationFragment on Notification {
    _id
    title
    isRead
    createdAt
    status
    bodyPlain
    bodyHtml
    url
    type
    channel
    priority
  }
`

export const notifcationQuery = buildGraphqlQuery('Notification', notificationFragment)

export const countQuery = gql`
  query allNotificationMeta($filter: JSON) {
    allNotificationMeta(filter: $filter) {
      count
    }
  }
`
